<div class="card">
	<div class="card-header">
		<span>{{title}}</span>
		<button (click)="close()" class="btn-close" title="Close"></button>
	</div>
	<div class="card-body">
		<app-tab-panel [displayMode]="tabPanelDisplayMode.horizontal">
			<app-dynamic-tab [title]="'Reporting Customizations'">
				<app-components-manager-reportingcustomizations *tabContent
					[partnerId]="partner.PartnerId">
				</app-components-manager-reportingcustomizations>
			</app-dynamic-tab>
			<app-dynamic-tab [title]="'Pro Tips'">
				<app-components-manager-protips *tabContent
					[partnerId]="partner.PartnerId"
					[partnerName]="partner.PartnerName">
				</app-components-manager-protips>
			</app-dynamic-tab>
		</app-tab-panel>
	</div>
	<div class="card-footer text-end">
		<button (click)="close()" class="btn btn-link">Close</button>
	</div>
</div>
